import styled from 'styled-components';

export const VerticalTabsStyled = styled.div<{
  $activeTabColor: string;
}>`
  & .vertical-tabs-label-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 10px;

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
    }

    & .vertical-tab {
      position: relative;
      min-width: fit-content;
      cursor: pointer;
      color: gray;
      padding: 10px 0px;
      text-align: center;

      &.active {
        color: black;

        & svg {
          stroke: black;
        }
      }
    }
  }

  & .tabs-content-container {
    width: 100%;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 12px;
    & .tab-icon {
      display: none;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 12px;
    & .tab-icon {
      display: none;
    }
  }
`;
